import React from 'react';

// Small, consistent line-icon set (24x24, stroke = currentColor) used in
// place of emoji across the item-type UI, so the app reads as a product
// rather than a toy. Sizing/color are controlled entirely by className.

const base = {
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const CarIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M4 16.5V11l2-5h12l2 5v5.5" />
    <path d="M3 16.5h18v2.5a1 1 0 0 1-1 1h-1.5a1 1 0 0 1-1-1V18H6.5v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2.5Z" />
    <path d="M6 11h12" />
    <circle cx="7.5" cy="16.5" r="1.1" fill="currentColor" stroke="none" />
    <circle cx="16.5" cy="16.5" r="1.1" fill="currentColor" stroke="none" />
  </svg>
);

export const BoxIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M3.5 8.2 12 4l8.5 4.2v7.6L12 20l-8.5-4.2Z" />
    <path d="M3.5 8.2 12 12l8.5-4.2" />
    <path d="M12 12v8" />
  </svg>
);

export const PawIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <ellipse cx="12" cy="16.2" rx="4.2" ry="3.4" />
    <ellipse cx="6.2" cy="10.5" rx="1.7" ry="2.1" />
    <ellipse cx="10.2" cy="7.3" rx="1.7" ry="2.2" />
    <ellipse cx="13.8" cy="7.3" rx="1.7" ry="2.2" />
    <ellipse cx="17.8" cy="10.5" rx="1.7" ry="2.1" />
  </svg>
);

export const EditIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M4 20h4L18.5 9.5a2.1 2.1 0 0 0-3-3L5.5 16l-1.5 4Z" />
    <path d="M14 6.5 17.5 10" />
  </svg>
);

export const TagIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M3.5 12.4V5.5A1.5 1.5 0 0 1 5 4h6.9c.4 0 .78.16 1.06.44l7.1 7.1a1.5 1.5 0 0 1 0 2.12l-6.9 6.9a1.5 1.5 0 0 1-2.12 0l-7.1-7.1A1.5 1.5 0 0 1 3.5 12.4Z" />
    <circle cx="8.3" cy="8.3" r="1.3" fill="currentColor" stroke="none" />
  </svg>
);

export const PrinterIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M6.5 8.5V4h11v4.5" />
    <rect x="3.5" y="8.5" width="17" height="8" rx="1.5" />
    <path d="M6.5 15.5v4.5h11v-4.5" />
    <path d="M7.5 12h1.5" />
  </svg>
);

export const TrashIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M4.5 6.5h15" />
    <path d="M9 6.5V4.8A1.3 1.3 0 0 1 10.3 3.5h3.4A1.3 1.3 0 0 1 15 4.8v1.7" />
    <path d="M6.5 6.5 7.3 19a1.5 1.5 0 0 0 1.5 1.4h6.4a1.5 1.5 0 0 0 1.5-1.4l.8-12.5" />
    <path d="M10 10.5v6M14 10.5v6" />
  </svg>
);

export const MessageIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M4 5.5h16A1.5 1.5 0 0 1 21.5 7v9a1.5 1.5 0 0 1-1.5 1.5H8l-4.5 3.5V7A1.5 1.5 0 0 1 4 5.5Z" />
    <path d="M8 10h8M8 13h5" />
  </svg>
);

export const EyeIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M2.5 12S6 5.5 12 5.5 21.5 12 21.5 12 18 18.5 12 18.5 2.5 12 2.5 12Z" />
    <circle cx="12" cy="12" r="2.8" />
  </svg>
);

export const EyeOffIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M2.5 12S6 5.5 12 5.5c1.8 0 3.3.5 4.6 1.2M21.5 12S18 18.5 12 18.5c-1.8 0-3.3-.5-4.6-1.2" />
    <path d="M9.6 10.4a2.8 2.8 0 0 0 3.9 3.9M4.2 5.2l15.6 13.6" />
  </svg>
);

export const DownloadIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M12 4v11.5" />
    <path d="M7.5 11 12 15.5 16.5 11" />
    <path d="M4.5 17.5V19a1.5 1.5 0 0 0 1.5 1.5h12a1.5 1.5 0 0 0 1.5-1.5v-1.5" />
  </svg>
);

export const CallIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M5.5 4.5h3l1.5 4-2 1.5a11 11 0 0 0 5.5 5.5l1.5-2 4 1.5v3a1.5 1.5 0 0 1-1.6 1.5A16 16 0 0 1 4 5.6 1.5 1.5 0 0 1 5.5 4.5Z" />
  </svg>
);

export const ClockIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <circle cx="12" cy="12" r="8.5" />
    <path d="M12 7.5V12l3 2" />
  </svg>
);

export const HistoryIcon = (props) => (
  <svg viewBox="0 0 24 24" width="1em" height="1em" {...base} {...props}>
    <path d="M4 12a8 8 0 1 1 2.6 5.9" />
    <path d="M4 12V7M4 12h5" />
    <path d="M12 8v4.5l3 2" />
  </svg>
);

export const TYPE_ICONS = {
  vehicles: CarIcon,
  assets: BoxIcon,
  pets: PawIcon,
};
